import { useEffect } from 'react';
import { useAxios } from 'src/hooks/use-axios';
import { Links, OptionalLinks } from 'src/types/api-utilities';

export type ShipperRegistrationPublicRoot = {
  _links: Links<
    | 'tsoAssignmentDocuments'
    | 'tsoAssignmentDocumentTemplate'
    | 'tsoRegistrationContact'
  >;
};

export function useShipperRegistrationPublic() {
  const shipperRegistrationPublic = useAxios(
    (axios, signal) =>
      axios.request<ShipperRegistrationPublicRoot>({
        signal,
        url: PRISMA_CONFIG.shipperRegistration + '/public',
        validateStatus: (status) =>
          // statuses 404 or 401 might occur only when deploying asynchronous FE & BE
          // (f.in. when BE endpoint '/public' is not deployed yet to prod)
          status === 200 || status === 404 || status === 401,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    shipperRegistrationPublic.execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return shipperRegistrationPublic;
}

export type ShipperRegistrationPublicRequest = ReturnType<
  typeof useShipperRegistrationPublic
>;

export type ShipperRegistrationRoot = {
  _links: OptionalLinks<'settings' | 'registrationInformationDocument'>;
};

export function useShipperRegistration() {
  const shipperRegistration = useAxios(
    (axios, signal) =>
      axios.request<ShipperRegistrationRoot>({
        signal,
        url: PRISMA_CONFIG.shipperRegistration,
        validateStatus: (status) =>
          status === 200 || status === 401 || status === 403 || status === 404,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    shipperRegistration.execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return shipperRegistration;
}

export type ShipperRegistrationRequest = ReturnType<
  typeof useShipperRegistration
>;
